var render = function render(){var _vm=this,_c=_vm._self._c;return _c('base-btn',_vm._b({attrs:{"to":{ name: 'Login' }}},'base-btn',_vm.$attrs,false),[_c('v-icon',{attrs:{"small":"","left":""}},[_vm._v("mdi-login")]),_c('span',[_vm._v("Liitu / Logi sisse")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }